/**
 * Authentication Endpoints
 */
import { getApiClient } from "../client";
import { USER_POPULATE } from "../populate";
import { ForgotPasswordInputSchema, ImpersonateResponseSchema, LocaleSchema, LoginInputSchema, LoginResponseSchema, RegisterInputSchema, RegisterResponseSchema, RenewTokenResponseSchema, ResetPasswordInputSchema, StrapiIdSchema, validateInput, } from "../schemas";
import { parseStrapiItemResponse, parseStrapiListResponse } from "../utils/parseStrapiResponse";
/**
 * Authentication endpoints
 */
export const authEndpoints = {
    /**
     * Login with email/username and password
     */
    async login(input) {
        const validated = validateInput(LoginInputSchema, input, "authEndpoints.login");
        const populate = USER_POPULATE.AUTH;
        const response = await getApiClient().post("/auth/local", validated, {
            params: { populate },
            headers: { Authorization: undefined },
        });
        return parseStrapiItemResponse(response.data, {
            schema: LoginResponseSchema,
            context: "authEndpoints.login",
        });
    },
    /**
     * Renew authentication token
     * Requires current valid token
     */
    async renewToken() {
        const populate = USER_POPULATE.AUTH;
        const response = await getApiClient().get("/auth/local/renew", {
            params: { populate },
        });
        return parseStrapiItemResponse(response.data, {
            schema: RenewTokenResponseSchema,
            context: "authEndpoints.renewToken",
        });
    },
    /**
     * Register a new user
     */
    async register(input) {
        const validated = validateInput(RegisterInputSchema, input, "authEndpoints.register");
        const populate = USER_POPULATE.AUTH;
        const response = await getApiClient().post("/auth/local/register", validated, {
            params: { populate },
            headers: { Authorization: undefined },
        });
        return parseStrapiItemResponse(response.data, {
            schema: RegisterResponseSchema,
            context: "authEndpoints.register",
        });
    },
    /**
     * Request password reset email
     */
    async forgotPassword(input) {
        const validated = validateInput(ForgotPasswordInputSchema, input, "authEndpoints.forgotPassword");
        const response = await getApiClient().post("/auth/forgot-password", validated, {
            headers: { Authorization: undefined },
        });
        return parseStrapiItemResponse(response.data);
    },
    /**
     * Reset password with code from email
     */
    async resetPassword(input) {
        const validated = validateInput(ResetPasswordInputSchema, input, "authEndpoints.resetPassword");
        const response = await getApiClient().post("/auth/reset-password", validated, {
            headers: { Authorization: undefined },
        });
        return parseStrapiItemResponse(response.data, {
            schema: LoginResponseSchema,
            context: "authEndpoints.resetPassword",
        });
    },
    /**
     * Upload a file (authenticated)
     */
    async uploadFile(file) {
        const response = await getApiClient().uploadFile(file);
        return parseStrapiItemResponse(response.data);
    },
    /**
     * Get available locales
     */
    async getLocales() {
        const response = await getApiClient().get("/i18n/locales");
        return parseStrapiListResponse(response.data, {
            schema: LocaleSchema,
            context: "authEndpoints.getLocales",
        });
    },
    /**
     * Impersonate a user (admin only)
     */
    async impersonateUser(userId) {
        const validatedId = validateInput(StrapiIdSchema, userId, "authEndpoints.impersonateUser");
        const response = await getApiClient().get(`/auth/local/user/${validatedId}`);
        return parseStrapiItemResponse(response.data, {
            schema: ImpersonateResponseSchema,
            context: "authEndpoints.impersonateUser",
        });
    },
    /**
     * Confirm email with token
     */
    async confirmEmail(token) {
        const response = await getApiClient().post("/auth/confirm-email", { token }, {
            headers: { Authorization: undefined },
        });
        return parseStrapiItemResponse(response.data);
    },
};
